// Theme is passed from material-ui withStyles
export default theme => ({
  authTitle: {
    paddingTop: theme.spacing(2),
  },
})
